import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { GeoIcon, MenuIcon } from "@boundary/components/mapIcons";
import { ResetIcon } from "@boundary/components/icons";
import { useMachineStore } from "@boundary/_hooks";
import { prefetchAndNavigate } from "@boundary/utils/prefetchRoute";
import styles from "./mapActionBar.module.scss";

interface MapActionBarProps {
  onMenuClick?: () => void;
  onRightClick?: () => void;
  onResetFilters?: () => void;
}

interface MapActionButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

function MapActionButton({ onClick, children }: MapActionButtonProps) {
  return (
    <button
      className={styles.actionButton}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

function ResetFiltersButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      className={styles.resetFiltersButton}
      onClick={onClick}
    >
      <span className={styles.resetFiltersText}>Сбросить фильтры</span>
      <ResetIcon size={24} />
    </button>
  );
}

export function MapActionBar({ onMenuClick, onRightClick, onResetFilters }: MapActionBarProps) {
  const navigate = useNavigate();
  const { filteredTypes, resetFilters } = useMachineStore();
  const hasActiveFilters = filteredTypes.length > 0;

  const handleMenuClick = useCallback(() => {
    if (onMenuClick) {
      onMenuClick();
    } else {
      prefetchAndNavigate(navigate, "/menu");
    }
  }, [onMenuClick, navigate]);

  const handleRightClick = useCallback(() => {
    if (onRightClick) {
      onRightClick();
    }
  }, [onRightClick]);

  const handleResetFilters = useCallback(() => {
    if (onResetFilters) {
      onResetFilters();
    } else {
      resetFilters();
    }
  }, [onResetFilters, resetFilters]);

  // Состояние Filter: показываем кнопку "Сбросить фильтры" в центре
  if (hasActiveFilters) {
    return (
      <div className={styles.container}>
        <MapActionButton onClick={handleMenuClick}>
          <MenuIcon size="small" />
        </MapActionButton>
        <ResetFiltersButton onClick={handleResetFilters} />
        <MapActionButton onClick={handleRightClick}>
          <GeoIcon size="small" />
        </MapActionButton>
      </div>
    );
  }

  // Состояние Base: обычные кнопки слева и справа
  return (
    <div className={styles.container}>
      <MapActionButton onClick={handleMenuClick}>
        <MenuIcon size="small" />
      </MapActionButton>
      <MapActionButton onClick={handleRightClick}>
        <GeoIcon size="small" />
      </MapActionButton>
    </div>
  );
}

